let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gJRco")).then(() => parcelRequire('6RHsa'));